import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { inputLabelClasses } from "@mui/material/InputLabel";
import { Autocomplete, Button } from "@mui/material";



export default function AxionAutoComplete(props) {

    const { text, value, options, color, variant, onChange,label,sx } = props
    return (

        <Autocomplete
            id="test"
            disablePortal 
            //size="small"
            slotProps={{
              paper: {
                sx: {
                  '& .MuiAutocomplete-listbox': {
                    '& .MuiAutocomplete-option': {
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                    },
                  },
                },
              },
            }}
            value={value}
            renderOption={(props, option) => (
                <li {...props}>
                  {option.label}
                </li>
              )}
            sx={{
              '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {          
                backgroundColor: '#ffffff',
                color: '#000000',
                "&:hover": {
                  backgroundColor: '#f0f0f0',
                },
              },
              "& .base-Popper-root": 
              {
                backgroundColor: "#ffffff !important",
              },
          "& .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']":
              {
                backgroundColor: "#ffffff",
              },
          "& .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true'] .Mui-focused":
              {
                backgroundColor: "#3878b4",
              },
              "& .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true'] .Mui-focused":
              {
                backgroundColor: "#3878b4",
              },
              "& .MuiFormControl-root":{
                '& + .MuiFormLabel-root .MuiInputLabel-shrink': {
                  top: '15px'
                },
               
              }
          
            }}
            
            renderInput={(params) => (
              <TextField {...params} 
                label={label}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      size: "small",
                      bgcolor: 'white',
                      color: 'black',
                      '& .MuiMenuItem-root': {
                        padding: 1,
                      },
                    },
                  },
                }}
                sx={{
            
                  '& .MuiInputBase-root': { 
                    bgcolor: 'white',
                    color: 'black',
                    overflow: 'hidden',
                    borderRadius: 1,
                    border: '3px solid',
                    borderColor:'#799c4a',
                    background:'#ffffff',
                    height: "50px"
                
                  },
                  // '& .MuiInputBase-input': {
                  //   paddingTop: '10px',
                  // },
                  '& .MuiInputBase-input': {
                    color: 'black',     // Ensures the input text is also black
                    marginTop: '4px',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'black'     // Ensures the input text is also black
                  },
                  '& .MuiSvgIcon-root': {
                    color: 'black',    // Changing the dropdown arrow to black
                  },
            
                '&.MuiInputBase-root': {
                  overflow: 'hidden',
                  borderRadius: 1,
                  border: '2px solid',
                  borderColor:'#799c4a',
                  background:'#ffffff',
                  color: 'black'
                },
                '& .MuiFormLabel-root.MuiInputLabel-shrink': {
                  top: '14px',
                  color: "#799c4a"
                },
               
                }} />)}
            options={options}
            onChange={onChange}
    
           />
  


    )
}


